import type { Template, TunaPlugin } from '@tunasong/plugin-lib'
import type { EntityType } from '@tunasong/schemas'
import { EntityAvatar, Typography } from '@tunasong/ui-lib'
import type { FC } from 'react'

interface CreateEntityCardsProps {
  plugin: TunaPlugin
  title: string
  description: string
  template?: Template
  selected?: boolean
  onSelect: () => void
}

/** Create one or more cards from a plugin */
export const TemplateCard: FC<CreateEntityCardsProps> = props => {
  const { onSelect, title, description, selected, plugin, template } = props

  const { template: templateContent } = template ?? {}

  if (!templateContent) {
    return null
  }

  return (
    <div
      onClick={onSelect}
      style={{
        borderColor: selected ? 'var(--tuna-palette-primary-dark)' : 'transparent',
        borderWidth: selected ? 2 : 1,
        borderStyle: 'solid',
        borderRadius: 8,
        cursor: 'pointer',
        padding: 16,
        ...(selected ? {} : { borderColor: 'var(--tuna-palette-divider)' }),
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 8 }}>
        <EntityAvatar type={plugin.node?.type as EntityType} />
        <Typography variant="subtitle1">{title}</Typography>
      </div>
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
    </div>
  )
}

export default TemplateCard
